import CryptoJS from 'crypto-js'

// 密钥 - 生产环境建议从后端获取或使用环境变量
const SECRET_KEY = 'J5kTBLlmBUQqUss3Ii105BwlGKvXF32l'

/**
 * AES 加密
 * @param {string} data - 需要加密的数据
 * @returns {string} 加密后的字符串
 */
export function encrypt(data) {
  if (!data) return ''
  try {
    const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY).toString()
    return encrypted
  } catch (error) {
    console.error('加密失败:', error)
    return ''
  }
}

/**
 * AES 解密
 * @param {string} encryptedData - 加密的数据
 * @returns {string} 解密后的字符串
 */
export function decrypt(encryptedData) {
  if (!encryptedData) return ''
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)
    return decrypted
  } catch (error) {
    console.error('解密失败:', error)
    return ''
  }
}

/**
 * MD5 哈希（单向加密，不可逆）
 * @param {string} data - 需要哈希的数据
 * @returns {string} MD5 哈希值
 */
export function md5Hash(data) {
  if (!data) return ''
  return CryptoJS.MD5(data).toString()
}

/**
 * SHA256 哈希（单向加密，不可逆，比 MD5 更安全）
 * @param {string} data - 需要哈希的数据
 * @returns {string} SHA256 哈希值
 */
export function sha256Hash(data) {
  if (!data) return ''
  return CryptoJS.SHA256(data).toString()
}

/**
 * Base64 编码
 * @param {string} data - 需要编码的数据
 * @returns {string} Base64 编码后的字符串
 */
export function base64Encode(data) {
  if (!data) return ''
  const wordArray = CryptoJS.enc.Utf8.parse(data)
  return CryptoJS.enc.Base64.stringify(wordArray)
}

/**
 * Base64 解码
 * @param {string} encodedData - Base64 编码的数据
 * @returns {string} 解码后的字符串
 */
export function base64Decode(encodedData) {
  if (!encodedData) return ''
  const wordArray = CryptoJS.enc.Base64.parse(encodedData)
  return wordArray.toString(CryptoJS.enc.Utf8)
}

